'use client';

import GtagService from '@/services/Gtag.service';
import { Ads } from '@/components/ads/ads';

export default function WhatsappHomeBanner({ img, hasSuperHighlight }: { img: any; hasSuperHighlight?: boolean }) {
  return (
    <div
      className={hasSuperHighlight ? 'section-ads-home' : 'page-content page-content-after-banner'}
      style={{ marginTop: 0, marginBottom: 85 }}
    >
      <a
        target="_blank"
        rel="noreferrer"
        href="https://whatsapp.com/channel/0029Vb5my6a5kg7CYjQ9tg16"
        onClick={() => GtagService.customEvent('whatsapp_banner')}
      >
        {/* Sem `unoptimized`: a arte agora e estatica, entao o next/image pode
            redimensionar e servir srcset. Era animada, e WebP animado perde a
            animacao ao ser otimizado — por isso a prop existia aqui. */}
        <Ads img={img} size="lg" />
      </a>
    </div>
  );
}
